import { hrPayrollRecordArea } from "./hrPayrollRecordRoutes";

const HR_PAYROLL_ROOTS = Object.freeze([
  "/app/hr",
  "/app/payroll",
  "/app/organisation",
  "/app/teachers",
  "/app/leave",
]);

const matchesRoot = (pathname, root) => pathname === root || pathname.startsWith(`${root}/`);

export function isHrPayrollExperiencePath(pathname) {
  const path = String(pathname || "").split("?")[0];
  return HR_PAYROLL_ROOTS.some((root) => matchesRoot(path, root));
}

export { HR_PAYROLL_ROOTS, hrPayrollRecordArea };
